import React from 'react'
import { MenuItem, TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { EnergyType } from '../../calculators/EnergyFlow'

type Props = {
  options: EnergyType[]
  value: EnergyType
  onChange: (value: EnergyType) => void
}

export function VisibleEnergyTypeSelect({
  options,
  value,
  onChange,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <TextField
      name="energy-type"
      value={value}
      onChange={(event) => onChange(event.target.value as EnergyType)}
      fullWidth
      select
    >
      {options.map((energyType) => (
        <MenuItem key={energyType} value={energyType}>
          {t(`energyType.${energyType}`)}
        </MenuItem>
      ))}
    </TextField>
  )
}
